import React from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import ODatePicker from "../shared/datePicker/ODatePicker";
import PhoneInputField from "../shared/FormFields/PhoneInputField";
import { ValidationMessage } from "../../utils/constants/validationMessage";
import { regex } from "../../utils/constants/regexVariables";
import { whiteSpaceCheck } from "../../helper/helper";
import { MaxLength } from "../../utils/constants/CharactersLength";
import { ErrorMessage } from "@hookform/error-message";
import { constantTypes } from "../../utils/constants/constant";

const DependentsInfo = ({
  familyMemberDOBError,
  handleChangeFamilyMemberDate,
  errors,
  register,
  familyMemberDOB,
  FamilyPhone,
  setFamilyPhone,
  setValue,
  fields,
  append,
  remove,
}) => {
  return (
    <div className="wrapper mw-100 position-relative mb-5 pb-2 px-md-4 px-3">
      <span className="wrapper-heading">Other Family Members</span>
      {fields.map((item, index) => (
        <div key={index} className={`border p-3 ${index !== 0 && "mt-3"}`}>
          {index !== 0 && (
            <Button
              className="bg-transparent border-0 p-0 ms-auto d-block mt-3"
              type="button"
              onClick={() => remove(index)}
            >
              <i className="bi bi-dash-circle-fill text-red fs-2"></i>
            </Button>
          )}
          <Row className="mb-3 gx-sm-3 gx-2">
            <Col xl={3} md={4} xs={6} className="mb-3">
              <Form.Group key={item.id} controlId={`formSurname${index}`}>
                <Form.Label>
                  Member name <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="First name"
                  name="firstName"
                  {...register(`familyInformation[${index}].firstName`, {
                    required: ValidationMessage.FIRST_NAME_REQUIRED,
                    validate: (value) => whiteSpaceCheck(value),
                  })}
                  maxLength={MaxLength.nameLen}
                />
                <ErrorMessage
                  errors={errors}
                  name={`familyInformation[${index}].firstName`}
                  render={({ message }) => (
                    <p className="error-message text-start py-2 px-1 text-danger">
                      {message}
                    </p>
                  )}
                />
              </Form.Group>
            </Col>
            <Col xl={3} md={4} xs={6} className="mb-3">
              <Form.Group key={item.id} controlId={`formGivenName${index}`}>
                <Form.Label>&nbsp;</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Last name"
                  name="lastName"
                  {...register(`familyInformation[${index}].lastName`, {
                    required: ValidationMessage?.LAST_NAME_REQUIRED,
                    validate: (value) => whiteSpaceCheck(value),
                  })}
                  maxLength={MaxLength.nameLen}
                />
                <ErrorMessage
                  errors={errors}
                  name={`familyInformation[${index}].lastName`}
                  render={({ message }) => (
                    <p className="error-message text-start py-2 px-1 text-danger">
                      {message}
                    </p>
                  )}
                />
              </Form.Group>
            </Col>
            <Col xl={3} md={4} sm={6} className="mb-3">
              <Form.Group key={item.id} controlId={`formEmail${index}`}>
                <Form.Label>
                  Date of Birth <span className="text-danger">*</span>
                </Form.Label>
                <ODatePicker
                  name="familyMemberDob"
                  value={
                    familyMemberDOB[index] && new Date(familyMemberDOB[index])
                  }
                  placeholder={"dob"}
                  errors={errors}
                  onChange={(dates) =>
                    handleChangeFamilyMemberDate(dates, index)
                  }
                  dateError={familyMemberDOBError[index]}
                  className="form-control"
                  maxDate={new Date()}
                />
              </Form.Group>
            </Col>

            <Col xl={3} md={4} sm={6} className="mb-3">
              <Form.Group
                className=""
                key={item.id}
                controlId={`formDesignation${index}`}
              >
                <Form.Label>Relation With</Form.Label>
                <Form.Select
                  name="relationWith"
                  {...register(`familyInformation[${index}].relationWith`, {
                    required: ValidationMessage?.RELATION_WITH_REQUIRED,
                    validate: (value) => whiteSpaceCheck(value),
                  })}
                >
                  <option value="">Select relation with</option>
                  <option value="wife">Wife</option>
                  <option value="husband">Husband</option>
                  <option value="father">Father</option>
                  <option value="mother">Mother</option>
                  <option value="son">Son</option>
                  <option value="daughter">Daughter</option>
                  <option value="brother">Brother</option>
                  <option value="sister">Sister</option>
                  <option value="grandParent">Grand Mother</option>
                  <option value="grandFather">Grand Father</option>
                  <option value="uncal">Uncal</option>
                  <option value="auntie">Auntie</option>
                  <option value="daughterInLaw">Daughter IN-LAW</option>
                  <option value="fatherInLaw">Father IN-LAW</option>
                  <option value="fatherInLaw">Father In-Law</option>
                  <option value="grandDaughter">Grand Daughter</option>
                  <option value="grandSon">Grand Son</option>
                </Form.Select>

                <ErrorMessage
                  errors={errors}
                  name={`familyInformation[${index}].relationWith`}
                  render={({ message }) => (
                    <p className="error-message text-start py-2 px-1 text-danger">
                      {message}
                    </p>
                  )}
                />
              </Form.Group>
            </Col>
            {/*
            <Col md={3} className="mb-3">
              <Form.Group key={item.id} controlId={`formDesignation${index}`}>
                <Form.Label>Designation *</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter designation"
                  name="designation"
                  {...register(`familyInformation[${index}].designation`, {
                    required: ValidationMessage.DESIGNATION_NAME_REQUIRED,
                    validate: (value) => whiteSpaceCheck(value),
                  })}
                />
                <ErrorMessage
                  errors={errors}
                  name={`familyInformation[${index}].designation`}
                  render={({ message }) => (
                    <p className="error-message text-start py-2 px-1 text-danger">
                      {message}
                    </p>
                  )}
                />
              </Form.Group>
            </Col> */}
            <Col xl={3} md={4} sm={6} className="mb-3">
              <Form.Group key={item.id} controlId={`formYearOfBirth${index}`}>
                <Form.Label>
                  Mobile number <span className="text-danger">*</span>
                </Form.Label>
                <PhoneInputField
                  register={register}
                  setValue={setValue}
                  errors={errors}
                  name={`familyInformation[${index}].mobile`}
                  validationMessage={ValidationMessage}
                  regex={regex}
                  countryCode="+91"
                  initialPhone=""
                  setPhone={(data) => {
                    const newFamilyPhone = [...FamilyPhone];
                    newFamilyPhone[index] = data;
                    setFamilyPhone(newFamilyPhone);
                  }}
                  phone={FamilyPhone[index] || ""}
                  className={""}
                />
                <ErrorMessage
                  errors={errors}
                  name={`familyInformation[${index}].mobile`}
                  render={({ message }) => (
                    <p className="error-message text-start py-2 px-1 text-danger">
                      {message}
                    </p>
                  )}
                />
              </Form.Group>
            </Col>

            <Col xl={3} md={4} sm={6} className="mb-3">
              <Form.Group key={item.id} controlId={`formDepartment${index}`}>
                <Form.Label>
                  Office/Department <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter department"
                  name="department"
                  {...register(`familyInformation[${index}].department`, {
                    required: ValidationMessage.DEPARTMENT_NAME_REQUIRED,
                    validate: (value) => whiteSpaceCheck(value),
                  })}
                />
                <ErrorMessage
                  errors={errors}
                  name={`familyInformation[${index}].department`}
                  render={({ message }) => (
                    <p className="error-message text-start py-2 px-1 text-danger">
                      {message}
                    </p>
                  )}
                />
              </Form.Group>
            </Col>

            <Col xl={3} md={4} sm={6} className="mb-3">
              <Form.Group key={item.id} controlId={`formEducation${index}`}>
                <Form.Label>Education</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter education"
                  name="education"
                  {...register(`familyInformation[${index}].education`, {
                    required: ValidationMessage.EDUCATION_REQUIRED,
                    validate: (value) => whiteSpaceCheck(value),
                  })}
                />
                <ErrorMessage
                  errors={errors}
                  name={`familyInformation[${index}].education`}
                  render={({ message }) => (
                    <p className="error-message text-start py-2 px-1 text-danger">
                      {message}
                    </p>
                  )}
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group key={item.id} controlId={`formSubscription${index}`}>
                <Form.Label>Marital Status</Form.Label>
                <div>
                  <Form.Check
                    inline
                    type="radio"
                    label="Married"
                    value="married"
                    {...register(`familyInformation[${index}].maritalStatus`, {
                      required: "Marital status is required",
                    })}
                    style={{ cursor: "pointer" }}
                  />
                  <Form.Check
                    inline
                    type="radio"
                    label="Un-Married"
                    value="unmarried"
                    {...register(`familyInformation[${index}].maritalStatus`, {
                      required: "Marital status is required",
                    })}
                    style={{ cursor: "pointer" }}
                  />
                </div>
                <ErrorMessage
                  errors={errors}
                  name={`familyInformation[${index}].maritalStatus`}
                  render={({ message }) => (
                    <p className="error-message text-start py-2 px-1 text-danger">
                      {message}
                    </p>
                  )}
                />
              </Form.Group>
            </Col>
          </Row>
        </div>
      ))}

      <Button
        className="bg-transparent border-0 p-0 ms-auto d-block mt-3"
        type="button"
        onClick={() => append(constantTypes.familyInformation)}
      >
        <i className="bi bi-plus-circle-fill text-orange fs-2"></i>
      </Button>
    </div>
  );
};

export default DependentsInfo;
